import { subselect } from './root';
import { propertiesSelector } from './properties';
import { PLAYER_STATE_STATUSES } from '../constants';

export const isPlayingSelector = (playerState) => {
  const { status } = propertiesSelector(playerState);

  return (
    [
      PLAYER_STATE_STATUSES.LOADING,
      PLAYER_STATE_STATUSES.BUFFERING,
      PLAYER_STATE_STATUSES.RESUMING_FROM_BUFFERING,
      PLAYER_STATE_STATUSES.PLAYING,
    ].indexOf(status) > -1
  );
};

export const playerIsPlayingSelector = subselect(isPlayingSelector);
